import { createContext } from 'react';
import { initialTemplateState } from '../Agenda.constants';

export const AgendaTemplatesContext = createContext(initialTemplateState);
